import CardMedia from "@material-ui/core/CardMedia";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { useState } from "react";


const useStyles = makeStyles(() =>
    createStyles({
        blank: {
            backgroundColor: "#E0E0E0",
            height: "100%",
            width: "100%",
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        circle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 60,
            borderRadius: 30,
            backgroundColor: "white",
            width: 60,
        },
        icon: {
            color: "#E0E0E0",
            backgroundColor: "white",
            height: 24,
            width: 24,
        },
    }),
);

interface ThumbnailProps {
    unitName: string;
    imageUrl: string;
}

export const Thumbnail: React.FC<ThumbnailProps> = ({
    unitName,
    imageUrl,
}) => {
    const styleClasses = useStyles();
    const [loaded, setLoaded] = useState(false);
    const [fetchOk, setFetchOk] = useState(true);

    if (fetchOk) {
        return (
            <CardMedia
                component="img"
                alt={unitName}
                width="100%"
                src={imageUrl}
                onError={() => {
                    setLoaded(true);
                    setFetchOk(false);
                }}
                onLoad={() => {
                    setLoaded(true);
                }}
                height={loaded ? "auto" : 0}
            />
        );
    } else {
        return(
            <div className={ styleClasses.blank }>
                <div className={ styleClasses.circle }>
                    <ImageNotSupportedIcon className={ styleClasses.icon } />
                </div>
            </div>
        );
    }
};

export default Thumbnail;
